var _classCallCheck = require("/media/data/Documents/code/javascript/mdxp/node_modules/@babel/runtime/helpers/classCallCheck");

var _require = require('@babel/helper-plugin-utils'),
    declare = _require.declare;

var BabelPluginExtractImportNames = function BabelPluginExtractImportNames() {
  "use strict";

  _classCallCheck(this, BabelPluginExtractImportNames);

  var names = [];
  this.state = {
    names: names
  };
  this.plugin = declare(function (api) {
    api.assertVersion(7);
    return {
      visitor: {
        ImportDeclaration: function ImportDeclaration(path) {
          path.traverse({
            Identifier: function Identifier(path) {
              if (path.key === 'local') {
                names.push(path.node.name);
              }
            }
          });
        }
      }
    };
  });
};

module.exports = BabelPluginExtractImportNames;